import React from "react";
import { useSelector, useDispatch } from "react-redux";
import type { RootState, AppDispatch } from "../../../../app/store";
import CheckoutNavigation from "./CheckoutNavigation";
import { goToPreviousStep } from "../../checkoutSlice";

interface CheckoutNavigationContainerProps {
  onPlaceBacsOrder: () => void;
  isPlacingOrder: boolean;
}

const CheckoutNavigationContainer: React.FC<
  CheckoutNavigationContainerProps
> = ({ onPlaceBacsOrder, isPlacingOrder }) => {
  const dispatch: AppDispatch = useDispatch();
  const { currentStep, isCurrentStepFormValid, selectedPaymentMethod } =
    useSelector((state: RootState) => state.checkout);

  const stepsOrder: RootState["checkout"]["currentStep"][] = [
    "billing",
    "shipping",
    "payment",
  ];

  const getCurrentFormId = (): string | undefined => {
    switch (currentStep) {
      case "billing":
        return "billing-address-form";
      case "shipping":
        return "shipping-address-form";
      default:
        return undefined;
    }
  };
  const formId = getCurrentFormId();

  const handlePrevious = () => {
    dispatch(goToPreviousStep());
  };

  const handleNextOrPlaceOrder = () => {
    if (currentStep === "payment") {
      // Logic is now simplified to only handle BACS or warn for others
      if (selectedPaymentMethod === "bacs") {
        onPlaceBacsOrder();
      } else {
        console.warn(
          "Place order clicked with an unhandled payment method:",
          selectedPaymentMethod
        );
      }
    }
  };

  return (
    <CheckoutNavigation
      currentStep={currentStep}
      stepsOrder={stepsOrder}
      isSubmitting={isPlacingOrder}
      canProceed={isCurrentStepFormValid}
      onPrevious={handlePrevious}
      onNextOrPlaceOrder={handleNextOrPlaceOrder}
      formId={formId}
      selectedPaymentMethod={selectedPaymentMethod}
    />
  );
};

export default CheckoutNavigationContainer;
